export default "__VITE_ASSET__COlyxHak__"